/**
 * CDN 节点详情 - 侧边导航菜单
 *
 * 通过 menuContentRender 挂载，只替换 ProLayout sider 的菜单内容区，
 * 保留 sider 的 CSS 结构，风格与系统其他页面完全一致。
 */

import {
  ArrowLeftOutlined,
  BarChartOutlined,
  CloudServerOutlined,
  InfoCircleOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { Menu } from 'antd';
import React from 'react';
import { history, useIntl, useParams } from 'umi';

const NodeSideMenu: React.FC = () => {
  const intl = useIntl();
  const { deviceCode, feature } = useParams<{
    deviceCode: string;
    feature?: string;
  }>();

  const t = (id: string, msg: string) =>
    intl.formatMessage({ id, defaultMessage: msg });

  const activeTab = feature || 'basic';
  const listPath = '/cdn-ops/nodes';
  const nodeBasePath = `${listPath}/${deviceCode}`;

  const menuGroups = [
    {
      type: 'group' as const,
      label: t('cdn.node.sideMenu.group.basic', '节点信息'),
      children: [
        {
          key: 'basic',
          icon: <InfoCircleOutlined />,
          label: t('cdn.node.tab.basic', '基本信息'),
        },
        {
          key: 'ips',
          icon: <CloudServerOutlined />,
          label: t('cdn.node.tab.ips', 'IP 管理'),
        },
        {
          key: 'config',
          icon: <SettingOutlined />,
          label: t('cdn.node.tab.config', '配置管理'),
        },
        {
          key: 'stats',
          icon: <BarChartOutlined />,
          label: t('cdn.node.tab.stats', '流量统计'),
        },
      ],
    },
  ];

  return (
    <Menu
      mode="inline"
      selectedKeys={[activeTab]}
      style={{ borderRight: 0 }}
      onClick={({ key }) => {
        if (key === '__back__') {
          history.push(listPath);
        } else {
          history.push(`${nodeBasePath}/${key}`);
        }
      }}
      items={[
        {
          key: '__back__',
          icon: <ArrowLeftOutlined />,
          label: t('cdn.node.sideMenu.backToList', '返回节点列表'),
        },
        { type: 'divider' },
        ...menuGroups,
      ]}
    />
  );
};

export default NodeSideMenu;
